import TravelClassSeatCountInterface from '../../interfaces/client/TravelClassSeatCount'

import constants from '../../config/constants'

const { economyTravelClass } = constants

export default (travelClassSeatCount: TravelClassSeatCountInterface) =>
  travelClassSeatCount.travelClass === economyTravelClass
